import { render } from "./FooterNavigation.vue?vue&type=template&id=2e7e3c16&scoped=true"
import script from "./FooterNavigation.vue?vue&type=script&lang=js"
export * from "./FooterNavigation.vue?vue&type=script&lang=js"

import "./FooterNavigation.vue?vue&type=style&index=0&id=2e7e3c16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e7e3c16"]])

export default __exports__